/* Landing YT - page scripts. Swiper init copied verbatim from landing-yt-static.html */
(function () {
  if (typeof Swiper === 'undefined') return;
document.querySelectorAll('[swiper="sw12"]').forEach((sliderComponent) => {
  const sliderMain = sliderComponent.querySelector('[swiper="slider-main"]');
  const sliderThumbs = sliderComponent.querySelector('[swiper="slider-thumbs"]');
  const buttonNextEl = sliderComponent.querySelector('[swiper="next-button"]');
  const buttonPrevEl = sliderComponent.querySelector('[swiper="prev-button"]');

  const thumbsSwiper = new Swiper(sliderThumbs, {
    slidesPerView: 5,
    spaceBetween: 5,
    freeMode: false,
    watchSlidesProgress: true,
    watchOverflow: true,
    centerInsufficientSlides: true,
    breakpoints: {
      768: { slidesPerView: 5, spaceBetween: 9 },
      480: { slidesPerView: 5, spaceBetween: 9 },
    },
  });

  function syncVideos(swiper) {
    const slides = swiper.slides;

    slides.forEach((slide, i) => {
      const video = slide.querySelector("video");
      if (!video) return;

      const isActive = i === swiper.activeIndex;

      if (isActive) {
        // Play active slide video
        video.muted = true; // required for programmatic play on mobile
        const p = video.play();
        if (p && typeof p.catch === "function") p.catch(() => { });
      } else {
        // Pause + reset all other slide videos
        video.pause();
        try { video.currentTime = 0; } catch (e) { }
      }
    });
  }

  const mainSwiper = new Swiper(sliderMain, {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: buttonNextEl,
      prevEl: buttonPrevEl,
    },
    thumbs: { swiper: thumbsSwiper },

    // IMPORTANT: these events cover init + slide changes
    on: {
      init(swiper) {
        syncVideos(swiper);
      },
      slideChangeTransitionStart(swiper) {
        // pause everything ASAP while sliding
        syncVideos(swiper);
      },
      slideChangeTransitionEnd(swiper) {
        // ensure the new active one plays after transition
        syncVideos(swiper);
      },
    },
  });

  // Keyboard accessibility for thumbs (keep your existing behavior)
  if (sliderThumbs) {
    sliderThumbs.querySelectorAll(".swiper-slide").forEach((slide, index) => {
      slide.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          thumbsSwiper.slideTo(index, 300);
        }
      });
    });
  }
});
})();

// ======================================================================
// STEPS CAROUSEL - Swiper initialization
// ======================================================================
function initializeStepsCarousel() {
  const stepsSwiperEl = document.querySelector('.steps-swiper');
  if (!stepsSwiperEl) return;

  // Check if Swiper is available
  if (typeof Swiper === 'undefined') {
    console.warn('[Steps Carousel] Swiper library not loaded');
    return;
  }

  const stepsSwiper = new Swiper('.steps-swiper', {
    slidesPerView: 1.2,
    spaceBetween: 16,
    pagination: {
      el: stepsSwiperEl.querySelector('.carousel-pagination'),
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      990: {
        slidesPerView: 3,
        spaceBetween: 40,
        enabled: false
      },
    },
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeStepsCarousel);
} else {
  initializeStepsCarousel();
}

/* Sticky nav links: scroll to the target section (data-section="<id>") */
document.querySelectorAll('.sticky-nav__link[data-section]').forEach(function (link) {
  link.setAttribute('role', 'link');
  link.setAttribute('tabindex', '0');
  var go = function () {
    var target = document.getElementById(link.getAttribute('data-section'));
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  link.addEventListener('click', go);
  link.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
});

/* Announcement countdown: ticks down from the numbers in the markup, restarts at zero */
(function () {
  var h = document.querySelector('.cc-timer .hours');
  var m = document.querySelector('.cc-timer .minutes');
  var s = document.querySelector('.cc-timer .seconds');
  if (!h || !m || !s) return;
  var start = (parseInt(h.textContent, 10) || 0) * 3600 + (parseInt(m.textContent, 10) || 0) * 60 + (parseInt(s.textContent, 10) || 0);
  var total = start;
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  setInterval(function () {
    total = total > 0 ? total - 1 : start;
    h.textContent = pad(Math.floor(total / 3600));
    m.textContent = pad(Math.floor((total % 3600) / 60));
    s.textContent = pad(total % 60);
  }, 1000);
})();
